import { Box } from '@material-ui/core';
import { OnlineOnboardingDetails } from '@nemuru-eng/js-api-client';
import { UAParser } from 'ua-parser-js';

import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

export function DigitalFootprintForm({ borrowerDetails }: { borrowerDetails: OnlineOnboardingDetails }) {
  if (!borrowerDetails.userAgent) return <></>;

  const parser = new UAParser(borrowerDetails.userAgent);
  const browser = parser.getBrowser();
  const device = parser.getDevice();

  return (
    <Box pt={2}>
      <FormGridContainer>
        <TextFormField
          name="browser"
          label="BROWSER"
          value={browser.name ? `${browser.name} ${browser.version}` : undefined}
        />
        <TextFormField
          name="device"
          label="DEVICE"
          value={device.model ? `${device.model} ${device.type} ${device.vendor}` : undefined}
        />

        <TextFormField name="locale" label="LOCALE" value={borrowerDetails.locale} />
        <TextFormField name="device" label="DEVICE" value={parser.getOS().name} />
      </FormGridContainer>
    </Box>
  );
}
